module.exports = __webpack_public_path__ + "static/kake-65afb5ac483e19d77d2d4273ed030eca.jpg";